module.exports = __webpack_public_path__ + "img/nginx.3203a468.svg";